import { CopyOutlined } from '@ant-design/icons'
import type { TablePaginationConfig, TableProps } from 'antd'
import { Avatar, Button, Card, message, Table, Tooltip } from 'antd'
import copy from 'copy-to-clipboard'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppAdmin } from 'api/app-admin'
import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { FEATURE } from 'constants/feature'
import { usePermission } from 'hooks/use-permission'
import { logError, logInfo } from 'utils/logger'

import './style.scss'

export default function AirDrop() {
  const [data, setData] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [current, setCurrent] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  // Fetch data with pagination
  const getData = async (pageIndex = 1, pageSize = 10) => {
    setLoading(true)
    try {
      const res = await AppAdmin.getListAirDrop(pageSize, pageIndex - 1)
      if (res?.data.success) {
        const list = res?.data.data.map((item: any, index: number) => ({
          key: `${pageIndex}-${index}`,
          bannerUrl: item?.bannerUrl,
          name: item?.name,
          contractAddress: item?.contractAddress,
          desc: item?.desc,
          // startClaimTime: item?.startClaimTime_ui,
          // endClaimTime: item?.endClaimTime_ui,
          startTime: item?.startTime_ui,
          endTime: item?.endTime_ui,
          code: item?.code,
        }))
        setData(list)
        logInfo(res?.data.data)
        setTotal(res?.data.totalCount)
      }
    } catch (error) {
      setData([])
      setTotal(0)
      logError('Error fetching data: ', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getData(current, pageSize)
  }, [current, pageSize])

  const { canCRUD } = usePermission()

  // Define table columns
  const columns: TableProps<any>['columns'] = [
    {
      title: 'Banber',
      dataIndex: 'bannerUrl',
      key: 'bannerUrl',
      width: 80,
      render: (logo) => <Avatar src={logo} size={50} />,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Contract Address',
      dataIndex: 'contractAddress',
      key: 'contractAddress',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://basescan.org/address/${text}`}
          >{`${text.slice(0, 8)}...${text.slice(-8)}`}</a>
          <Tooltip title="Copy">
            <Button
              type="link"
              icon={<CopyOutlined />}
              onClick={() => {
                copy(text)
                message.success('Copied Success!')
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    // {
    //   title: "Description",
    //   dataIndex: "desc",
    //   key: "desc",
    // },
    {
      title: 'Start Time',
      dataIndex: 'startTime',
      key: 'startTime',
    },
    {
      title: 'End Time',
      dataIndex: 'endTime',
      key: 'endTime',
    },
    // {
    //   title: "Start Claim Time",
    //   dataIndex: "startClaimTime",
    //   key: "startClaimTime",
    // },
    // {
    //   title: "End Claim Time",
    //   dataIndex: "endClaimTime",
    //   key: "endClaimTime",
    // },
    {
      title: 'Details',
      dataIndex: 'detail',
      key: 'detail',
      render: (_, record) => (
        <Button
          className="button-detail"
          onClick={() => {
            navigate(`/airdrop/${record.code}`)
          }}
        >
          View
        </Button>
      ),
    },
  ]

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current: newPage, pageSize: newPageSize } = pagination
    setCurrent(newPage || 1)
    setPageSize(newPageSize || 10)
  }

  const navigate = useNavigate()

  return (
    <div className="main-section user">
      <Breadcrumb additionalItems={[{ title: 'Airdrop' }]} />
      <div className="main-title" style={{ marginBottom: 20 }}>
        Airdrop
      </div>
      <div style={{ marginBottom: 15, textAlign: 'start' }}>
        <Button
          size="large"
          style={{ width: 200 }}
          disabled={!canCRUD(FEATURE.AIRDROP)}
          type="primary"
          onClick={() => navigate('/airdrop/create')}
        >
          Create
        </Button>
      </div>
      <Card style={{ margin: '0 auto' }}>
        <Table<any>
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={total < 11 ? false : { total, current, pageSize }}
          onChange={handleTableChange}
          scroll={{ x: 1000 }}
          bordered
        />
      </Card>
    </div>
  )
}
